import { RecordMask } from '@skinsoft/types'

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const closedReportSummaryAreaRecordMasks: RecordMask = {
    name: {
        translatedString: {
            fr: 'Masque Reporter',
        },
        translatedId: null,
    },
    categories: [
        {
            label: {
                translatedString: {
                    fr: '',
                    'fr-ca': '',
                    en: '',
                    'en-us': '',
                    nl: '',
                    es: '',
                    it: '',
                    no: '',
                    de: '',
                    se: '',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5e7b836714256b1944f069f9",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "stateOfConservations",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "StateOfConservation"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreportcs.complex.StateOfConservation"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5e7b836714256b1944f069f7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeStateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeStateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.typeStateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142309",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5e7b836714256b1944f069f6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "stateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "stateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.stateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142308",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5e7b836714256b1944f069f8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142310",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.stateOfConservations",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142311",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeStateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeStateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.typeStateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142309",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "stateOfConservation",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "stateOfConservation"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.stateOfConservation",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142308",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5e7b836714256b1944f069f8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.stateOfConservations.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142310",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5d4c49000de7d241b997e14b",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "predictInterventions",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "PredictIntervention"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.PredictIntervention"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5d4c49000de7d241b997e149",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeIntervention",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeIntervention"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.typeIntervention",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142346",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "5d4c49000de7d241b997e14a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142348",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.predictInterventions",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142350",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5d4c49000de7d241b997e149",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "typeIntervention",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "typeIntervention"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.typeIntervention",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142346",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5d4c49000de7d241b997e14a",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.predictInterventions.precision",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142348",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Signatures',
                    'fr-ca': 'Signatures',
                    en: 'Signatures',
                    'en-us': 'Signatures',
                    nl: 'Handtekeningen',
                    es: 'Firmas',
                    it: 'Firme',
                    no: 'Underskriver',
                    de: 'Unterschriften',
                    se: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "5a3925ec08813b0001387c69",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "signers",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "Signer"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.Signer"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "5aab921d2ab79c000137ee1c",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "signer",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.signer",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142292",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "65b9137e9b743e28af07c63d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "positionOfSignatory",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "function"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.positionOfSignatory",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142295",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "65b9137e9b743e28af07c63e",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "dateOfSignature",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.dateOfSignature",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142297",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.signers",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142300",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "5aab921d2ab79c000137ee1c",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "signer",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.signer",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142292",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "65b9137e9b743e28af07c63d",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "positionOfSignatory",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "function"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.positionOfSignatory",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142295",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "65b9137e9b743e28af07c63e",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "dateOfSignature",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.signers.dateOfSignature",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142297",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
            ],
        },
        {
            label: {
                translatedString: {
                    fr: 'Contre-signatures',
                    'fr-ca': 'Contre-signatures',
                    en: 'Counter-signatures',
                    'en-us': 'Counter-signatures',
                    nl: 'Tegenhandtekeningen',
                    es: 'Contrafirmas',
                    it: 'Controfirme',
                    no: 'Kontrasignaturer',
                    de: 'Gegenunterschriften',
                    se: 'MISSING TRANSLATION',
                },
                translatedId: null,
            },
            maskFields: [
                {
                    columnDisplay: null,
                    entityField: {
                        entityFieldId: "6697633c46a2065e41f15fcd",
                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                        "entity": "conditionReport",
                        "schema": "conditionReportCS",
                        "name": "counterSignatures",
                        "mandatorySystem": false,
                        "type": {
                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                            "type": "List",
                            "entityFieldType": {
                                "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                "type": "CounterSignature"
                            },
                            "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.CounterSignature"
                        },
                        "entityFields": [
                            {
                                entityFieldId: "6697633c46a2065e41f15fc8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "reason",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "conditionReportMotif"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.reason",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1732531635496",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "6697633c46a2065e41f15fc6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "date",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.date",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142392",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "6697633c46a2065e41f15fc7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "location",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.location",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142393",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "6697633c46a2065e41f15fc5",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "comment",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.comment",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142390",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            {
                                entityFieldId: "6697633c46a2065e41f15fcc",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "observationCarriedPresenceOfs",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "ObservationCarriedPresenceOf"
                                    },
                                    "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.ObservationCarriedPresenceOf"
                                },
                                "entityFields": [
                                    {
                                        entityFieldId: "6697633c46a2065e41f15fc9",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "surnameFirstName",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                            "type": "TranslatedString"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.surnameFirstName",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523142395",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    {
                                        entityFieldId: "6697633c46a2065e41f15fca",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "function",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "function"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.function",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1732531635499",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                ],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142402",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                        ],
                        "isChildren": false,
                        "isInList": false,
                        "path": "conditionReportCS.counterSignatures",
                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List",
                        "isReadOnly": false,
                        "isComputed": false,
                        "weight": 1.0,
                        "needId": false,
                        "usableForFacets": false,
                        "isFieldConditionNumbering": false,
                        "lastModificationTimestamp": "1722523142403",
                        "backwardSearchEnable": false,
                        "fieldExcludeCheckInstitution": false
                    },
                    children: [
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "6697633c46a2065e41f15fc8",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "reason",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                    "type": "ThesaurusTerm",
                                    "thesaurusIdentifier": "conditionReportMotif"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.reason",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1732531635496",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "6697633c46a2065e41f15fc6",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "date",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "SkinDate"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.date",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.date.SkinDate",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142392",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "6697633c46a2065e41f15fc7",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "location",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.location",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142393",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "6697633c46a2065e41f15fc5",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "comment",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                    "type": "TranslatedString"
                                },
                                "entityFields": [],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.comment",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": true,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142390",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: null,
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        },
                        {
                            columnDisplay: null,
                            entityField: {
                                entityFieldId: "6697633c46a2065e41f15fcc",
                                "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                "entity": "conditionReport",
                                "schema": "conditionReportCS",
                                "name": "observationCarriedPresenceOfs",
                                "mandatorySystem": false,
                                "type": {
                                    "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ListEntityFieldType",
                                    "type": "List",
                                    "entityFieldType": {
                                        "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                        "type": "ObservationCarriedPresenceOf"
                                    },
                                    "listClass": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.complex.ObservationCarriedPresenceOf"
                                },
                                "entityFields": [
                                    {
                                        entityFieldId: "6697633c46a2065e41f15fc9",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "surnameFirstName",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                            "type": "TranslatedString"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.surnameFirstName",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523142395",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    {
                                        entityFieldId: "6697633c46a2065e41f15fca",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "function",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "function"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.function",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1732531635499",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                ],
                                "isChildren": true,
                                "isInList": true,
                                "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs",
                                "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List",
                                "isReadOnly": false,
                                "isComputed": false,
                                "weight": 1.0,
                                "needId": false,
                                "usableForFacets": false,
                                "isFieldConditionNumbering": false,
                                "lastModificationTimestamp": "1722523142402",
                                "backwardSearchEnable": false,
                                "fieldExcludeCheckInstitution": false
                            },
                            children: [
                                {
                                    columnDisplay: null,
                                    entityField: {
                                        entityFieldId: "6697633c46a2065e41f15fc9",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "surnameFirstName",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.SimpleEntityFieldType",
                                            "type": "TranslatedString"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.surnameFirstName",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.translatedstring.TranslatedString",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1722523142395",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    children: null,
                                    fieldFormat: undefined,
                                    formatter: undefined,
                                    inputComponent: undefined,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: undefined
                                },
                                {
                                    columnDisplay: null,
                                    entityField: {
                                        entityFieldId: "6697633c46a2065e41f15fca",
                                        "className": "org.skinsoft.backend.types.entityfield.EntityField",
                                        "entity": "conditionReport",
                                        "schema": "conditionReportCS",
                                        "name": "function",
                                        "mandatorySystem": false,
                                        "type": {
                                            "className": "org.skinsoft.backend.types.entityfield.fieldtypes.ThesaurusEntityFieldType",
                                            "type": "ThesaurusTerm",
                                            "thesaurusIdentifier": "function"
                                        },
                                        "entityFields": [],
                                        "isChildren": true,
                                        "isInList": true,
                                        "path": "conditionReportCS.counterSignatures.observationCarriedPresenceOfs.function",
                                        "pathType": "org.skinsoft.backend.schemas.conditionreport.conditionreportcs.ConditionReportCS|java.util.List|java.util.List|org.skinsoft.backend.types.thesaurusterm.ThesaurusTerm",
                                        "isReadOnly": false,
                                        "isComputed": false,
                                        "weight": 1.0,
                                        "needId": false,
                                        "usableForFacets": true,
                                        "isFieldConditionNumbering": false,
                                        "lastModificationTimestamp": "1732531635499",
                                        "backwardSearchEnable": false,
                                        "fieldExcludeCheckInstitution": false
                                    },
                                    children: null,
                                    fieldFormat: undefined,
                                    formatter: undefined,
                                    inputComponent: undefined,
                                    mandatoryUser: false,
                                    order: 0,
                                    tableDisplay: undefined
                                },
                            ],
                            fieldFormat: undefined,
                            formatter: undefined,
                            inputComponent: undefined,
                            mandatoryUser: false,
                            order: 0,
                            tableDisplay: undefined
                        }
                    ],
                    fieldFormat: undefined,
                    formatter: undefined,
                    inputComponent: undefined,
                    mandatoryUser: false,
                    order: 0,
                    tableDisplay: undefined
                },
            ],
        },
    ],
    level: 'adminLevel',
    userId: '595ca6a7857aba0001a00001',
    entityTargetId: '736bb6b8857abf0001ac9888',
    entityTarget: 'recolement',
    isInputMask: true,
    categoriesDisplay: true,
    workspaceCreation: '5d6917c3fb6ee95ed082f268',
    workspaceSharing: [],
    isPatternMask: false,
    pattern: null,
    _links: {
        self: {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'record-masks': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650',
        },
        'mask-fields': {
            href: 'http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650/mask-fields',
        },
    },
    id: '6070579b0a6d211f1520a650',
}
